import React, { useEffect, useState } from "react";
import { axiosLatest } from "../../axios";
import { withRouter } from "react-router-dom";
import { sendRequestToLogging } from "../../ErrorBoundary";
import BatchOptionCard from "../paymentsComponents/batchOptionCard";
import SkeletonElement from "../../Skeletons/skeletonElement";
import { ERROR_MESSAGE } from "../constants";
import OfferLabel from "../paymentsComponents/offerLabel";

function UpcomingBatchesComponent(props) {
  const {
    handleUpdate: handleToUpdate,
    paymentsPageSetState,
    courseSlug,
    paymentsPageFlag,
    courseType,
    selfPacedCourseUpcomingBatchData,
    upcomingBatches,
    selectedBatch,
    currency,
    courseFeeType,
    isLoggedIn,
    fetchingBatchesData,
    setFetchingBatchesData,
  } = props;

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (courseType !== 1) loadData();
    else {
      paymentsPageSetState({
        upcomingBatches: [selfPacedCourseUpcomingBatchData],
        hasUpcomingBatchesData: true,
      });
    }
  }, []);

  useEffect(() => {
    if (!isLoggedIn || !upcomingBatches?.length || !isInitialLoad) return;
    const regBtnKey = courseType === 1 ? "register_btn" : "register_button";

    const alreadyRegisteredBatch = upcomingBatches?.find(
      (batch) =>
        batch?.[regBtnKey]?.action === "user_already_registered_in_batch" &&
        batch?.[regBtnKey]?.sub_action === "pay_fee"
    );

    setIsInitialLoad(false);

    alreadyRegisteredBatch
      ? handleToUpdate(alreadyRegisteredBatch)
      : handleToUpdate(upcomingBatches[0]);
  }, [upcomingBatches, courseType, isLoggedIn, courseType, isInitialLoad]);

  async function loadData() {
    setFetchingBatchesData(true);
    await axiosLatest
      .get(`/courses/${courseSlug}/meta/`)
      .then((res) => {
        paymentsPageSetState({
          upcomingBatches: res.data.all_upcoming_batches,
          hasUpcomingBatchesData: true,
          currency: res.data.payment_currency_symbol,
        });
      })
      .catch((err) => {
        sendRequestToLogging(
          JSON.stringify({
            traceback:
              "error = " +
              err +
              " \n URL = " +
              window.location.href +
              "\ntraceback: \n" +
              err.stack,
          })
        );
        alert(ERROR_MESSAGE);
      })
      .finally(() => {
        setFetchingBatchesData(false);
      });
  }

  if (
    paymentsPageFlag &&
    (!upcomingBatches || upcomingBatches.length === 0) &&
    !fetchingBatchesData
  )
    return (
      <div>
        <h2 className="font-weight-bold text-left">No Active Batch</h2>
      </div>
    );

  return (
    <section id="batches" className="upcoming_batches_container">
      <div
        className={`upcoming_batches ${
          fetchingBatchesData ? "padding_for_shimmer" : ""
        }`}
      >
        {props?.isCourseEligibleForSale && (
          <OfferLabel
            classes="for_payment_details_card"
            text="Extra 35% Off"
          />
         )}
        {fetchingBatchesData ? (
          <div className="header_shimmer">
            <SkeletonElement type="main_heading_shimmer" />
          </div>
        ) : (
          <>
            <h4 className="main_heading">Batches Available</h4>
          </>
        )}

        {fetchingBatchesData ? (
          <SkeletonElement type="heading_shimmer" />
        ) : (
          <p className="heading">
            Select your batch:
            <span>&#9733;</span>
          </p>
        )}

        {fetchingBatchesData ? (
          <div className="options_shimmer">
            {[...new Array(2)].map((_, i) => (
              <SkeletonElement key={i} type="option_shimmer" />
            ))}
          </div>
        ) : (
          <div className="options">
            {upcomingBatches?.map((b) => (
              <BatchOptionCard
                batch={b}
                key={b.batch_id}
                courseType={courseType}
                selectedBatch={selectedBatch}
                currency={currency}
                courseFeeType={courseFeeType}
                isLoggedIn={isLoggedIn}
                onSelectBatch={() => handleToUpdate(b)}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default withRouter(UpcomingBatchesComponent);
